import React from 'react'
import PropTypes from 'prop-types'
import {Regular, Strong, Small} from '@modifi/ui'
import {Currency} from '@modifi/enums'
import {FormattedNumber} from '@modifi/plugin-i18n'
import {collectAmounts} from '../../../../util'
import {MATCH_GROUP_PAYMENT} from '../../../match/constants'

const AmountDetails = ({amount, currency, splitAmounts, matchGroup, isBox}) => {
  const updatedAmounts = collectAmounts(splitAmounts)
  const paymentType = matchGroup === MATCH_GROUP_PAYMENT // for figuring colSpan
  return (
    <tbody>
      <tr>
        <td colSpan={paymentType ? 7 : 4} height={50} aria-hidden />
        <td colSpan={2}>
          <Strong>Total to be matched: </Strong>
        </td>
        <td>
          <Regular ml={isBox ? 15 : 35}>
            <FormattedNumber currency={currency}>{updatedAmounts || ''}</FormattedNumber>
          </Regular>
        </td>
      </tr>
      <tr>
        <td colSpan={paymentType ? 7 : 4} aria-hidden />
        <td colSpan={2}>
          <Strong>Amount left to be matched: </Strong>
        </td>
        <td>
          <Regular ml={isBox ? 15 : 35}>
            <FormattedNumber currency={currency}>{amount - updatedAmounts}</FormattedNumber>
          </Regular>
        </td>
      </tr>
      {amount - updatedAmounts > 0 && (
        <tr>
          <td colSpan={paymentType ? 7 : 4} aria-hidden />
          <td colSpan={4}>
            <Small>(This will be added to its own transaction and can be matched later)</Small>
          </td>
        </tr>
      )}
    </tbody>
  )
}

AmountDetails.propTypes = {
  amount: PropTypes.string.isRequired,
  currency: PropTypes.oneOf(Object.values(Currency)).isRequired,
  matchGroup: PropTypes.string.isRequired,
  isBox: PropTypes.bool,
  splitAmounts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
}

AmountDetails.defaultProps = {
  isBox: false,
}

export default AmountDetails
